'use client';

var styles = {"container":"Modal-module_container__3WNLk","fullHeight":"Modal-module_fullHeight__2eTDg","isOpen":"Modal-module_isOpen__1NTwW","header":"Modal-module_header__3u27A","left":"Modal-module_left__3XZ16","right":"Modal-module_right__pC5v1","title":"Modal-module_title__I4YyR","icon":"Modal-module_icon__KpEGB","backdrop":"Modal-module_backdrop__1vqZk","closeIcon":"Modal-module_closeIcon__3IfFp","footer":"Modal-module_footer__2vpNe"};

export { styles as default };
//# sourceMappingURL=Modal.module.css.js.map
